<template>
  <div class="booking-promoters-promoter_sidewindow-related_contacts dbox">
    <NTable
      id="booking-promoters-promoter_sidewindow-related_contacts"
      :items="contactRelations"
      :headers="headers"
      :config="invoiceTableConfig"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('relation')">
            <input
              type="text"
              class="ntable--textfield"
              name="relation"
              id="relation"
              :value="item['relation']"
              v-on:blur="e => onRelationTextBoxBlur(e, item)"
            />
          </td>
          <td v-bind="tdcon('name')">
            <span>{{ item["contact_name"] }}</span>
          </td>
          <td v-bind="tdcon('phone')">
            <span>{{ item["phone1"] }}</span>
          </td>
          <td v-bind="tdcon('email')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => sendEmail(item['email1'])"
                src="static/icons/email/email-grey.svg"
                class="dt-icon v5 s1"
                :alt="$t('mail')"
                :title="$t('mail')"
                v-if="item['email1']"
              />
            </div>
          </td>
          <td v-bind="tdcon('option')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                @click.stop="e => removeArtist(item)"
                class="dt-icon v5 s1"
                :alt="$t('delete')"
                :title="$t('delete')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </div>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../../plugins/datatable";

import { bookingPromotersService as BPS } from "../../../services/booking-promoters.service";

export default {
  components: {
    NTable
  },
  props: ["promoterOverview"],
  data: function() {
    return {
      invoiceTableConfig: createNTableConfig({
        headerStyle: 2,
        fullHeight: true
      }),
      artistCalendarDateModalContainer: false,
      artistCalendarDateModal: false,
      // contactRelations: []
    };
  },
  watch: {
    // promoterOverview: function(n, o) {
    //   this.contactRelations = n.contact_relations;
    // }
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("relation"), //
        createTableHeader("name"),
        createTableHeader("phone"),
        createTableHeader("email", { text: false, mw: 40 }),
        createTableHeader("option", { text: false, mw: 40 })
      ];
    },
    contactRelations: function() {
      return this.promoterOverview.contact_relations || [];
    }
  },
  methods: {
    sendEmail(emailAddress) {
      window.location = `mailto:${emailAddress}`;
    },
    onRelationTextBoxBlur: function(e, item) {
      BPS.modify_contact_relations(
        item.contact_relation_id,
        "relation",
        e.target.value
      );
    },
    removeArtist: function(item) {
      this.$emit('deleted', item);
      // let contactRelationId = item.contact_relation_id;
      // this.contactRelations = this.contactRelations.filter(
      //   e => e.contact_relation_id != contactRelationId
      // );
      // BookingService.deleteContactRelation({
      //   contactRelationId
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
.promoter-overview-related-contact {
}
</style>
